import { useState } from 'react';
import { serviceAreas, serviceActions } from '../../data/MenuItems';

/**
 * Hook to manage service area and action selection state with filtering logic.
 * @returns {object} Service options state and handlers including selected values, filtered lists, and change handlers.
 */
export const useServiceOptions = () => {
  const [serviceAreaSelected, setServiceAreaSelected] = useState({ serviceArea: '', enabled: true });
  const [serviceActionSelected, setServiceActionSelected] = useState({
    serviceArea: '',
    item: '',
    itemValue: '',
    enabled: true,
  });

  const filteredServiceAreas = serviceAreas.filter((item) => item.enabled === true);
  const filteredServiceActions = serviceActions.filter(
    (item) => item.serviceArea === serviceAreaSelected.serviceArea && item.enabled === true,
  );

  const handleServiceAreaChange = (event) => {
    setServiceAreaSelected(event);
    setServiceActionSelected({ serviceArea: '', item: '', itemValue: '', enabled: true });
  };

  const handleServiceActionChange = (event) => {
    setServiceActionSelected(event);
  };

  const reset = () => {
    setServiceAreaSelected({ serviceArea: '', enabled: true });
    setServiceActionSelected({ serviceArea: '', item: '', itemValue: '', enabled: true });
  };

  return {
    serviceAreaSelected,
    serviceActionSelected,
    filteredServiceAreas,
    filteredServiceActions,
    handleServiceAreaChange,
    handleServiceActionChange,
    reset,
  };
};
